export enum CHECKBOX_TEST_IDS {
	CHECKBOX_INPUT = 'checkbox_input',
}
